import { useTranslation } from 'react-i18next';

/**
 * Calm onboarding copy when locations exist but no displays yet.
 * Keeps the setup ladder visible without duplicating header CTAs.
 */
export function DisplaysSetupHint() {
  const { t } = useTranslation('displays');
  return (
    <div
      className="rounded-xl border border-line px-4 py-3.5"
      style={{ background: 'var(--gs-panel)' }}
    >
      <p className="m-0 text-sm font-semibold text-ink">{t('setupHint.title')}</p>
      <p className="m-0 mt-1 text-sm text-muted">{t('setupHint.body')}</p>
    </div>
  );
}
